<template>

    <form ref="tutorialvideo-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-6">
                <label for="tutorialVideoFuncionalidadeId">Funcionalidade do Video Tutorial</label>
                <select v-select="{ dataitem: 'TutorialVideoFuncionalidade', default: 'Selecione' }" v-model="model.tutorialVideoFuncionalidadeId" class="form-control" name="tutorialVideoFuncionalidadeId" required></select>
            </div>
            <div class="form-group col-md-6">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="model.nome" required />
            </div>
            <div class="form-group col-md-12">
                <label for="titulo">Título</label>
                <input type="text" class="form-control" name="titulo" placeholder="Título" v-model="model.titulo" required />
            </div>
            <div class="form-group col-md-12">
                <label for="descricao">Descrição</label>
                <textarea type="text" class="form-control" name="descricao" placeholder="Descrição" v-model="model.descricao" />
            </div>
            <div class="form-group col-md-12">
                <label for="uRLApresentacao">URL da Página</label>
                <input type="text" class="form-control" name="uRLApresentacao" placeholder="URL da Página" v-model="model.uRLApresentacao" required />
            </div>
            <div class="form-group col-md-12">
                <label for="videoReferencia">Url do Vídeo</label>
                <input type="text" class="form-control" name="videoReferencia" placeholder="Url do Vídeo" v-model="model.videoReferencia" required />
            </div>
            <div class="form-group col-md-6">
                <label for="dtAtualizacao">Data Atualização</label>
                <input type="date" v-datepicker class="form-control" name="dtAtualizacao" v-model="model.dtAtualizacao" />
            </div>
            <div class="form-group col-md-4">
                <label for="ordemApresentacao">Ordem de Apresentação</label>
                <input type="text" class="form-control" name="ordemApresentacao" placeholder="Ordem de Apresentação" v-model="model.ordemApresentacao" />
            </div>
            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "tutorialvideo-form-create",
        mixins: [base],
        data: () => ({

            model: {
                tutorialVideoFuncionalidadeId: ''
            },

            form: "tutorialvideo-form-create",

            resources: {
                create: 'tutorialvideo',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

